import React from 'react';
import { Link } from 'react-router-dom';
import Proptypes from 'prop-types';
import {
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  CardFooter,
} from 'reactstrap';
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import LogoHeader from '../../commons/LogoHeader';
import './Forgot.scss';
import { ButtonLogin, H1Login, BackButton } from '../../styled-components';
import { ReactComponent as IconBack } from '../../images/icn_back.svg';
import variables from '../../variables';

function ForgotPresentational({ forgotError, forgotSuccess, match, onForgot }) {
  const { t } = useTranslation('FORGOT');
  const { handleSubmit, register, errors } = useForm();

  return (
    <div className="App">
      <LogoHeader match={match} />

      <section>
        <div className="container">
          <H1Login>
            {t('FORGOT')}
            <br />
            <span>{t('RECOVER')}</span>
          </H1Login>
          <Card className="u-center-horizontal login-card">
            <Form onSubmit={handleSubmit(onForgot)}>
              <CardBody>
                <Link to={'/'}>
                  <BackButton type="button">
                    <IconBack fill={variables.primary} /> Torna al Login
                  </BackButton>
                </Link>
                <br />
                <br />
                <FormGroup>
                  <Label>{t('COMMON:EMAIL')}</Label>
                  <Input
                    type="email"
                    name="email"
                    innerRef={register({
                      required: t('COMMON:REQUIRED'),
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i,
                        message: t('COMMON:INVALID_EMAIL'),
                      },
                    })}
                  />
                  {errors.email && errors.email.message && (
                    <FormText className="error-message">
                      {errors.email.message}
                    </FormText>
                  )}
                </FormGroup>

                {forgotSuccess && (
                  <FormText className="result-message">
                    {t('SUCCESS_1')}
                    <br />
                    <Link to="/reset">{t('SUCCESS_2')}</Link>
                  </FormText>
                )}
              </CardBody>
              <CardFooter>
                <ButtonLogin type="submit" className="u-center-horizontal">
                  {t('RESET')}
                </ButtonLogin>
              </CardFooter>
            </Form>
          </Card>
        </div>
      </section>
    </div>
  );
}

ForgotPresentational.propTypes = {
  onForgot: Proptypes.func.isRequired,
};

export default ForgotPresentational;
